export const configMultipliersData = [
	{
		id: 0,
		rows: 6,
		risk_level: 'SUIGAR_low',
		multipliers: [4, 1.5, 0.9, 0.5, 0.9, 1.5, 4],
	},
	{
		id: 1,
		rows: 6,
		risk_level: 'SUIGAR_medium',
		multipliers: [6, 1.8, 0.7, 0.4, 0.7, 1.8, 6],
	},
	{
		id: 2,
		rows: 6,
		risk_level: 'SUIGAR_high',
		multipliers: [8, 2, 0.6, 0.2, 0.6, 2, 8],
	},
	{
		id: 3,
		rows: 7,
		risk_level: 'SUIGAR_low',
		multipliers: [5, 1.4, 1.1, 0.7, 0.7, 1.1, 1.4, 5],
	},
	{
		id: 4,
		rows: 7,
		risk_level: 'SUIGAR_medium',
		multipliers: [10, 2, 1, 0.5, 0.5, 1, 2, 10],
	},
	{
		id: 5,
		rows: 7,
		risk_level: 'SUIGAR_high',
		multipliers: [20, 2.9, 0.7, 0.2, 0.2, 0.7, 2.9, 20],
	},
	{
		id: 6,
		rows: 8,
		risk_level: 'SUIGAR_Low',
		multipliers: [5, 2, 1.1, 1, 0.5, 1, 1.1, 2, 5],
	},
	{
		id: 7,
		rows: 8,
		risk_level: 'SUIGAR_Medium',
		multipliers: [11, 3, 1.3, 0.7, 0.4, 0.7, 1.3, 3, 11],
	},
	{
		id: 8,
		rows: 8,
		risk_level: 'SUIGAR_High',
		multipliers: [26, 4, 1.5, 0.3, 0.2, 0.3, 1.5, 4, 26],
	},
	{
		id: 9,
		rows: 9,
		risk_level: 'SUIGAR_Low',
		multipliers: [5.1, 2, 1.5, 1, 0.7, 0.7, 1, 1.5, 2, 5.1],
	},
	{
		id: 10,
		rows: 9,
		risk_level: 'SUIGAR_Medium',
		multipliers: [16, 4, 1.6, 0.9, 0.5, 0.5, 0.9, 1.6, 4, 16],
	},
	{
		id: 11,
		rows: 9,
		risk_level: 'SUIGAR_High',
		multipliers: [45, 6, 2, 0.6, 0.2, 0.2, 0.6, 2, 6, 45],
	},
	{
		id: 12,
		rows: 10,
		risk_level: 'SUIGAR_Low',
		multipliers: [8, 2, 1.4, 1.1, 1, 0.5, 1, 1.1, 1.4, 2, 8],
	},
	{
		id: 13,
		rows: 10,
		risk_level: 'SUIGAR_Medium',
		multipliers: [20, 4, 2, 1.4, 0.6, 0.4, 0.6, 1.4, 2, 4, 20],
	},
	{
		id: 14,
		rows: 10,
		risk_level: 'SUIGAR_High',
		multipliers: [65, 10, 3, 0.9, 0.3, 0.2, 0.3, 0.9, 3, 10, 65],
	},
	{
		id: 15,
		rows: 11,
		risk_level: 'SUIGAR_Low',
		multipliers: [8.4, 3, 2, 1.1, 1, 0.7, 0.7, 1, 1.1, 2, 3, 8.4],
	},
	{
		id: 16,
		rows: 11,
		risk_level: 'SUIGAR_Medium',
		multipliers: [24, 5, 3, 1.7, 0.7, 0.5, 0.5, 0.7, 1.7, 3, 5, 24],
	},
	{
		id: 17,
		rows: 11,
		risk_level: 'SUIGAR_High',
		multipliers: [100, 14, 5, 1.4, 0.4, 0.2, 0.2, 0.4, 1.4, 5, 14, 100],
	},
	{
		id: 18,
		rows: 12,
		risk_level: 'SUIGAR_Low',
		multipliers: [9, 3, 1.4, 1.3, 1.1, 1, 0.5, 1, 1.1, 1.3, 1.4, 3, 9],
	},
	{
		id: 19,
		rows: 12,
		risk_level: 'SUIGAR_Medium',
		multipliers: [30, 10, 3.5, 2, 1.1, 0.6, 0.3, 0.6, 1.1, 2, 3.5, 10, 30],
	},
	{
		id: 20,
		rows: 12,
		risk_level: 'SUIGAR_High',
		multipliers: [150, 20, 8, 2, 0.7, 0.2, 0.2, 0.2, 0.7, 2, 8, 20, 150],
	},
	{
		id: 21,
		rows: 13,
		risk_level: 'SUIGAR_Low',
		multipliers: [8, 4, 3, 1.6, 1.2, 0.9, 0.7, 0.7, 0.9, 1.2, 1.6, 3, 4, 8],
	},
	{
		id: 22,
		rows: 13,
		risk_level: 'SUIGAR_Medium',
		multipliers: [40, 10, 5, 3, 1.3, 0.7, 0.4, 0.4, 0.7, 1.3, 3, 5, 10, 40],
	},
	{
		id: 23,
		rows: 13,
		risk_level: 'SUIGAR_High',
		multipliers: [220, 33, 11, 4, 1, 0.2, 0.2, 0.2, 0.2, 1, 4, 11, 33, 220],
	},
	{
		id: 24,
		rows: 14,
		risk_level: 'SUIGAR_Low',
		multipliers: [7, 4, 1.6, 1.3, 1.2, 1.1, 1, 0.5, 1, 1.1, 1.2, 1.3, 1.6, 4, 7],
	},
	{
		id: 25,
		rows: 14,
		risk_level: 'SUIGAR_Medium',
		multipliers: [50, 10, 5, 4, 2, 1, 0.5, 0.2, 0.5, 1, 2, 4, 5, 10, 50],
	},
	{
		id: 26,
		rows: 14,
		risk_level: 'SUIGAR_High',
		multipliers: [400, 50, 17, 5, 1.9, 0.3, 0.2, 0.2, 0.2, 0.3, 1.9, 5, 17, 50, 400],
	},
	{
		id: 27,
		rows: 15,
		risk_level: 'SUIGAR_Low',
		multipliers: [11, 5, 3, 2, 1.3, 1.1, 1, 0.7, 0.7, 1, 1.1, 1.3, 2, 3, 5, 11],
	},
	{
		id: 28,
		rows: 15,
		risk_level: 'SUIGAR_Medium',
		multipliers: [80, 15, 12, 4, 3, 1.3, 0.5, 0.3, 0.3, 0.5, 1.3, 3, 4, 12, 15, 80],
	},
	{
		id: 29,
		rows: 15,
		risk_level: 'SUIGAR_High',
		multipliers: [600, 80, 23, 8, 3, 0.5, 0.2, 0.2, 0.2, 0.2, 0.5, 3, 8, 23, 80, 600],
	},
	{
		id: 30,
		rows: 16,
		risk_level: 'SUIGAR_Low',
		multipliers: [12, 5, 2, 1.3, 1.2, 1.2, 1.1, 1, 0.5, 1, 1.1, 1.2, 1.2, 1.3, 2, 5, 12],
	},
	{
		id: 31,
		rows: 16,
		risk_level: 'SUIGAR_Medium',
		multipliers: [100, 40, 10, 5, 3, 1.3, 1, 0.5, 0.3, 0.5, 1, 1.3, 3, 5, 10, 40, 100],
	},
	{
		id: 32,
		rows: 16,
		risk_level: 'SUIGAR_High',
		multipliers: [1000, 110, 20, 9, 4, 2, 0.2, 0.2, 0.2, 0.2, 0.2, 2, 4, 9, 20, 110, 1000],
	},
];
